class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");

    if (facetForm) {
      facetForm.addEventListener("input", (evt) => {
        /*
         * FIX DECANT BAR
         * On ignore les événements générés automatiquement par le thème.
         * Cela évite une boucle de rerender sur la page /search.
         */
        if (!evt.isTrusted) return;

        /*
         * Le système de facettes ne doit réagir qu'aux vrais contrôles
         * de filtres, pas au champ principal de recherche.
         */
        const target = evt.target;

        if (
          target &&
          (
            target.type === "search" ||
            target.name === "q" ||
            target.name === "options[prefix]"
          )
        ) {
          return;
        }

        FacetFiltersForm.loading.start();
        this.debouncedOnSubmit(evt);
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener("popstate", onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    /*
     * FIX DECANT BAR
     * Ne jamais rerender exactement les mêmes paramètres.
     */
    if (
      updateURLHash &&
      searchParams === FacetFiltersForm.searchParamsPrev
    ) {
      FacetFiltersForm.loading.finish();
      return;
    }

    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (FacetFiltersForm.section) {
      window.scroll({
        top: FacetFiltersForm.section.offsetTop - 100,
        left: 0,
        behavior: "smooth",
      });
    }

    FacetFiltersForm.loading.finish();

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];

        FacetFiltersForm.renderFilters(html, event);

        FacetFiltersForm.renderElements(
          html,
          "[data-product-container]",
          FacetFiltersForm.selectors.productGrid
        );

        FacetFiltersForm.renderElements(
          html,
          "[data-facet-form]",
          FacetFiltersForm.selectors.filtersForm
        );

        FacetFiltersForm.renderProductCount(html);

        document.dispatchEvent(
          new CustomEvent("collection:rerendered")
        );
      })
      .catch((error) => {
        console.error("Facet render error:", error);
        FacetFiltersForm.loading.finish();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

    FacetFiltersForm.renderFilters(html, event);

    FacetFiltersForm.renderElements(
      html,
      "[data-product-container]",
      FacetFiltersForm.selectors.productGrid
    );

    FacetFiltersForm.renderElements(
      html,
      "[data-facet-form]",
      FacetFiltersForm.selectors.filtersForm
    );

    FacetFiltersForm.renderProductCount(html);

    document.dispatchEvent(
      new CustomEvent("collection:rerendered")
    );
  }

  static renderElements(html, el, selector) {
    const elementContainer = document.querySelector(el);

    if (!elementContainer) return;

    const parsedHTML = new DOMParser().parseFromString(
      html,
      "text/html"
    );

    const newElement = parsedHTML.querySelector(el);

    if (!newElement) return;

    elementContainer.innerHTML = newElement.innerHTML;

    FacetFiltersForm.loading =
      new window.FoxTheme.AnimateLoading(
        document.body,
        {
          overlay: document.querySelector(selector),
        }
      );

    if (typeof __reInitTooltip === "function") {
      __reInitTooltip(elementContainer);
    }
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(
      html,
      "text/html"
    );

    const newCount = parsedHTML.querySelector(
      FacetFiltersForm.selectors.productCount
    );

    const container = document.querySelector(
      FacetFiltersForm.selectors.productCount
    );

    if (!newCount || !container) return;

    container.innerHTML = newCount.innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(
      html,
      "text/html"
    );

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter"
    );

    const matchesIndex = (element) => {
      const jsFilter = event
        ? event.target.closest(".js-filter")
        : undefined;

      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };

    const facetsToRender = Array.from(
      facetDetailsElements
    ).filter(
      (element) => !matchesIndex(element)
    );

    facetsToRender.forEach((element) => {
      const target = document.querySelector(
        `.f-facets__block[data-index="${element.dataset.index}"]`
      );

      if (!target) return;

      target.textContent = "";

      const child =
        element.querySelector("collapsible-tab") ||
        element.querySelector("#Mobile-SortBy-Block");

      if (child) {
        target.appendChild(child);
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement =
        html.querySelector(selector);

      if (!activeFacetsElement) return;

      const currentElement =
        document.querySelector(selector);

      if (!currentElement) return;

      currentElement.innerHTML =
        activeFacetsElement.innerHTML;
    });
  }

  static updateURLHash(searchParams) {
    const newUrl =
      `${window.location.pathname}` +
      `${searchParams ? "?".concat(searchParams) : ""}`;

    /*
     * FIX DECANT BAR
     * Ne crée pas une nouvelle entrée d'historique
     * si l'URL est déjà identique.
     */
    const currentUrl =
      window.location.pathname +
      window.location.search;

    if (currentUrl === newUrl) return;

    history.pushState(
      { searchParams },
      "",
      newUrl
    );
  }

  static getSections() {
    return [
      {
        section: FacetFiltersForm.sectionId,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    if (
      form.id === "FacetFiltersForm" &&
      !FoxThemeSettings.isMobile
    ) {
      formData.delete("sort_by");
    }

    return new URLSearchParams(
      formData
    ).toString();
  }

  onSubmitForm(searchParams, event) {
    /*
     * FIX DECANT BAR
     * Deuxième sécurité anti-boucle.
     */
    if (
      searchParams ===
      FacetFiltersForm.searchParamsPrev
    ) {
      FacetFiltersForm.loading.finish();
      return;
    }

    FacetFiltersForm.renderPage(
      searchParams,
      event
    );
  }

  onSubmitHandler(event) {
    const sortFilterForms =
      document.querySelectorAll(
        "facet-filters-form form"
      );

    if (FoxThemeSettings.isMobile) {
      const form =
        event.target.closest("form");

      if (!form) return;

      const searchParams =
        this.createSearchParams(form);

      this.onSubmitForm(
        searchParams,
        event
      );
    } else {
      const forms = [];

      sortFilterForms.forEach((form) => {
        forms.push(
          this.createSearchParams(form)
        );
      });

      this.onSubmitForm(
        forms.join("&"),
        event
      );
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    const url =
      event.currentTarget.href.indexOf("?") === -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.selectors = {
  container: ".f-facets__container",
  productGrid: "[data-products-grid]",
  productCount: "[data-product-count]",
  filtersForm: "[data-facet-form]",
  facetWrapper: "[data-facets-wrapper]",
  facetBlock: ".f-facets__block",
};

FacetFiltersForm.section =
  document.querySelector(
    "#ProductGridContainer"
  );

FacetFiltersForm.sectionId =
  FacetFiltersForm.section &&
  FacetFiltersForm.section.dataset.sectionId;

FacetFiltersForm.domNodes =
  queryDomNodes(
    FacetFiltersForm.selectors,
    FacetFiltersForm.section
  );

FacetFiltersForm.loading =
  new window.FoxTheme.AnimateLoading(
    document.body,
    {
      overlay: document.querySelector(
        FacetFiltersForm.selectors.productGrid
      ),
    }
  );

FacetFiltersForm.filterData = [];

FacetFiltersForm.searchParamsInitial =
  window.location.search.slice(1);

FacetFiltersForm.searchParamsPrev =
  window.location.search.slice(1);

if (
  !customElements.get(
    "facet-filters-form"
  )
) {
  customElements.define(
    "facet-filters-form",
    FacetFiltersForm
  );
}

FacetFiltersForm.setListeners();


class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      inputs: ['input[type="number"]'],
      ranges: ['input[type="range"]'],
      minRange: '[data-type="min-range"]',
      maxRange: '[data-type="max-range"]',
      minInput: '[data-type="min-input"]',
      maxInput: '[data-type="max-input"]',
    };

    this.domNodes = queryDomNodes(
      this.selectors,
      this
    );

    this.priceGap =
      parseInt(this.dataset.priceGap);

    this.priceMax =
      parseInt(this.dataset.priceMax);

    this.domNodes.inputs.forEach((el) =>
      el.addEventListener(
        "change",
        this.onInputChange.bind(this)
      )
    );

    this.domNodes.ranges.forEach((el) =>
      el.addEventListener(
        "input",
        this.onSliderChange.bind(this)
      )
    );

    this.setMinAndMaxValues();
  }

  onSliderChange(event) {
    const input =
      event.currentTarget;

    const type =
      input.dataset.type;

    const value =
      Number(input.value);

    const {
      minInput,
      maxInput,
      minRange,
      maxRange,
    } = this.domNodes;

    if (type === "min-range") {
      if (
        maxRange.value -
          input.value >=
        this.priceGap
      ) {
        minInput.value =
          input.value;
      } else {
        input.value =
          maxRange.value -
          this.priceGap;
      }
    }

    if (type === "max-range") {
      if (
        input.value -
          minRange.value >=
        this.priceGap
      ) {
        maxInput.value =
          input.value;
      } else {
        input.value =
          Number(minRange.value) +
          Number(this.priceGap);
      }
    }

    this.style.setProperty(
      "--price-min",
      (100 * minRange.value) /
        this.priceMax +
        "%"
    );

    this.style.setProperty(
      "--price-max",
      (100 * maxRange.value) /
        this.priceMax +
        "%"
    );
  }

  onInputChange(event) {
    this.adjustToValidValues(
      event.currentTarget
    );

    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const {
      minInput,
      maxInput,
    } = this.domNodes;

    if (maxInput.value) {
      minInput.setAttribute(
        "max",
        Number(maxInput.value) -
          this.priceGap
      );
    }

    if (minInput.value) {
      maxInput.setAttribute(
        "min",
        Number(minInput.value) +
          this.priceGap
      );
    }

    if (minInput.value === "") {
      maxInput.setAttribute(
        "min",
        0
      );
    }

    if (maxInput.value === "") {
      minInput.setAttribute(
        "max",
        maxInput.getAttribute("max")
      );
    }
  }

  adjustToValidValues(input) {
    const value =
      Number(input.value);

    const min =
      Number(
        input.getAttribute("min")
      );

    const max =
      Number(
        input.getAttribute("max")
      );

    if (value < min) {
      input.value = min;
    }

    if (value > max) {
      input.value = max;
    }
  }
}

if (!customElements.get("price-range")) {
  customElements.define(
    "price-range",
    PriceRange
  );
}


class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const link =
      this.querySelector("a");

    if (!link) return;

    link.addEventListener(
      "click",
      (e) => {
        e.preventDefault();

        const form =
          this.closest(
            "facet-filters-form"
          ) ||
          document.querySelector(
            "facet-filters-form"
          );

        if (form) {
          form.onActiveFilterClick(e);
        }
      }
    );
  }
}

if (!customElements.get("facet-remove")) {
  customElements.define(
    "facet-remove",
    FacetRemove
  );
}


class ApplyButton extends HTMLElement {
  constructor() {
    super();

    const drawer =
      this.closest(
        "drawer-component"
      );

    const button =
      this.querySelector(
        "button"
      );

    if (!button) return;

    button.addEventListener(
      "click",
      (e) => {
        e.preventDefault();

        if (drawer) {
          drawer.closeDrawer(false);
        }
      }
    );
  }
}

if (!customElements.get("facet-apply")) {
  customElements.define(
    "facet-apply",
    ApplyButton
  );
}